import defaultTheme from "./default";
import dark from "./dark";

const themes = {
  defaultTheme,
  dark
};

export default themes;
